import { Component, ElementRef, EventEmitter, ViewChild } from "@angular/core";
import { NgbTypeahead } from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs/Observable";
import { debounceTime, distinctUntilChanged, map } from "rxjs/operators";
import { AlertService } from "../../alert/services/alert.service";
import { Tag } from "../../models/Tag";
import { TagService } from "../../services/tag.service";

@Component({
  selector: "app-tag-selector",
  providers: [TagService],
  outputs: ["tagAdded", "tagRemoved"],
  inputs: ["tags", "maxTags", "culture", "inputClass"],
  template: `
    <div class="{{ inputClass }}">
      <label for="typeahead"
        >Tags <small>(MAX {{ maxTags }})</small></label
      >
      <ng-template #rt let-r="result" let-t="term">
        <ngb-highlight
          [result]="r.Name"
          [term]="t"
          (click)="openTypeahead()"
        ></ngb-highlight>
      </ng-template>
      <div class="input-group">
        <input
          name="typeahead"
          type="text"
          class="form-control"
          [(ngModel)]="tagSelected"
          [ngbTypeahead]="search"
          [inputFormatter]="formatter"
          [resultTemplate]="rt"
          [editable]="false"
          (keyup.enter)="addTag()"
          #instance="ngbTypeahead"
          #elem
        />
        <div class="input-group-btn">
          <button
            type="button"
            id="AddTagBtn"
            class="btn btn-primary mar0 ng-binding"
            tabindex="-1"
            (click)="addTag()"
          >
            <i class="fa fa-plus"></i>Add
          </button>
        </div>
      </div>
      <div
        class="form-group w100 post-tag-item"
        style="display: flex; flex-wrap: wrap; margin-top: 10px"
      >
        <div
          class="countryItem countryItem-info countryItem-dismissible"
          *ngFor="let tag of SelectedTags"
          role="alert"
        >
          <button
            type="button"
            class="close"
            data-dismiss="alert"
            (click)="removeTag(tag)"
            style="right:-5px;top:0px;"
          >
            <span aria-hidden="true">&times;</span>
            <span class="sr-only">x</span>
          </button>
          <span>{{ tag.Name }}</span>
        </div>
      </div>
    </div>
  `,
})
export class TagSelectorComponent {
  private AllTags: Tag[] = [];
  private tagSelected: Tag;
  private loaded: boolean = false;

  @ViewChild("instance") instance: NgbTypeahead;
  @ViewChild("elem") elem: ElementRef;

  culture: string = "en";
  maxTags: number = 5;
  inputName: string = "typeahead";
  tags: Tag[] = [];
  inputClass: string;

  tagAdded = new EventEmitter<Tag>();
  tagRemoved = new EventEmitter<Tag>();

  constructor(
    private tagService: TagService,
    private alertService: AlertService
  ) {
    this.loadTags();
  }

  public openTypeahead(): void {
    this.elem.nativeElement.dispatchEvent(new Event("input"));
    this.elem.nativeElement.focus();
  }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        this.AllTags.filter(
          (v) => v.Name.toLowerCase().indexOf(term.toLowerCase()) > -1
        ).slice(0, 10)
      )
    );

  formatter = (x: Tag) => x.Name;

  loadTags() {
    this.tagService.GetTagsByLanguage(this.culture).subscribe((tags: Tag[]) => {
      tags.map((tag) => this.AllTags.push(tag));
    });
  }

  addTag() {
    if (this.tagSelected && this.validateTag(this.tagSelected)) {
      this.tagAdded.emit(this.tagSelected);
      this.tagSelected = null;
    }
  }

  removeTag(tag: Tag) {
    this.tagRemoved.emit(tag);
  }

  validateTag(tag: Tag) {
    if (this.tags.some((x) => x.Id == tag.Id)) {
      this.alertService.add(
        "warning",
        `[${tag.Name} tag] is already selected.`
      );
      return false;
    }
    if (this.tags.length === this.maxTags) {
      this.alertService.add(
        "warning",
        `You cannot create more than ${this.maxTags} tags.`
      );
      return false;
    }
    return true;
  }

  get SelectedTags() {
    if (!this.tags 
        || this.tags.length === 0
        || !this.AllTags 
        || this.AllTags.length === 0) 
          return undefined;

    if (this.loaded) return this.tags;

    const getName = (id: string) => {
      const tag = this.AllTags.find((tag) => tag.Id === id);
      if (!tag)
        return null;

      return tag.Name;
    };
    this.tags.forEach(function (t) {
      t.Name = t.Name || getName(t.Id);
    });

    this.loaded = true;
    return this.tags;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/tagSelector/tagSelector.component.ts